// deckFacets — facet collection + filtering for the Topics picker. Facets are
// orthogonal to the Domain→Subject→Topic hierarchy: a deck's free-form `tags`
// (which absorb audience/exam-board/year-level for now) and the `difficulties`
// present in its items. Pure + framework-free for unit testing.

// collectFacets — the union of tags + difficulty levels across the deck list,
// for populating the filter controls. Sorted (tags alphabetical, difficulties
// numeric ascending).
export function collectFacets(decks) {
  const tags = new Set();
  const difficulties = new Set();
  for (const d of decks || []) {
    for (const t of d.tags || []) tags.add(t);
    for (const n of d.difficulties || []) difficulties.add(n);
  }
  return {
    tags: [...tags].sort((a, b) => a.localeCompare(b)),
    difficulties: [...difficulties].sort((a, b) => a - b)
  };
}

// isFilterActive — whether any facet constrains the list.
export function isFilterActive({ tags = [], difficulty = null } = {}) {
  return (Array.isArray(tags) && tags.length > 0) || difficulty != null;
}

// filterDecks — keep decks matching the active facets. Tags are OR within the
// selection (a deck matches if it carries ANY selected tag); difficulty matches
// if the deck has an item at that level. An empty/absent facet doesn't constrain.
export function filterDecks(decks, { tags = [], difficulty = null } = {}) {
  const tagSet = new Set(tags);
  return (decks || []).filter((d) => {
    const tagOk = tagSet.size === 0 || (d.tags || []).some((t) => tagSet.has(t));
    const diffOk = difficulty == null || (d.difficulties || []).includes(difficulty);
    return tagOk && diffOk;
  });
}
